import { useEffect, useCallback, useRef } from 'react';

type UseSimplePopUpProps = {
  onClose?: () => void;
};

export const useSimplePopUp = ({ onClose }: UseSimplePopUpProps) => {
  const popupRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      const target = event.target as Node;

      if (!document.contains(target)) {
        return;
      }

      if (popupRef.current && !popupRef.current.contains(target)) {
        onClose?.();
      }
    },
    [onClose],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  return { popupRef };
};
